var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.socketData.slice().reverse()),function(i){return _c('div',{key:i},[_c('LogCard',{attrs:{"log":i}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }